// Shared formatters for the Partner Home dashboard. Money is always integer
// cents + an ISO currency (never summed across currencies — doc 09 decision #5).

export const money = (cents, currency, opts = {}) =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency || "USD",
    maximumFractionDigits: 0,
    ...opts,
  }).format((cents || 0) / 100)

// Compact money for dense tables/headers, e.g. "$10,176".
export const num = (n) => (n || 0).toLocaleString()

export const pct = (n) => `${(n || 0).toFixed(1)}%`

// Signed value with a leading +/- for deltas.
export const signed = (n) => `${n > 0 ? "+" : ""}${num(n)}`

export const signedMoney = (cents, currency) =>
  `${cents > 0 ? "+" : cents < 0 ? "-" : ""}${money(Math.abs(cents), currency)}`

export const relativeTime = (iso) => {
  const mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000)
  if (mins < 60) return `${mins}m`
  const hrs = Math.round(mins / 60)
  if (hrs < 24) return `${hrs}h`
  return `${Math.round(hrs / 24)}d`
}
